export { Modal, type ModalBtn, type BaseModalProps } from './Modal';
